import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "target", "disabled"]
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.href && _ctx.useVueRouter)
    ? (_openBlock(), _createBlock(_component_router_link, _mergeProps({
        key: 0,
        to: _ctx.href,
        target: _ctx.openInNewTab? '_blank': '_self'
      }, _ctx.$attrs, {
        class: ["tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-transition tw-duration-150 disabled:tw-opacity-60 disabled:tw-cursor-not-allowed", _ctx.buttonClasses],
        disabled: _ctx.disabled
      }), {
        default: _withCtx(() => [
          (_ctx.enableLoading)
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                icon: "circle-notch",
                spin: "",
                class: "tw-h-4 tw-w-4"
              }))
            : (_ctx.icon)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 1,
                  icon: _ctx.icon,
                  class: "tw-h-4 tw-w-4"
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["to", "target", "class", "disabled"]))
    : (_ctx.href)
      ? (_openBlock(), _createElementBlock("a", _mergeProps({
          key: 1,
          href: _ctx.href,
          target: _ctx.openInNewTab? '_blank': '_self'
        }, _ctx.$attrs, {
          class: ["tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-transition tw-duration-150 disabled:tw-opacity-60 disabled:tw-cursor-not-allowed", _ctx.buttonClasses],
          disabled: _ctx.disabled
        }), [
          (_ctx.enableLoading)
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                icon: "circle-notch",
                spin: "",
                class: "tw-h-4 tw-w-4"
              }))
            : (_ctx.icon)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 1,
                  icon: _ctx.icon,
                  class: "tw-h-4 tw-w-4"
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default")
        ], 16, _hoisted_1))
      : (_openBlock(), _createElementBlock("button", _mergeProps({
          key: 2,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click', $event)))
        }, _ctx.$attrs, {
          class: ["tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-transition tw-duration-150 disabled:tw-opacity-60 disabled:tw-cursor-not-allowed", _ctx.buttonClasses],
          disabled: _ctx.disabled
        }), [
          (_ctx.enableLoading)
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                icon: "circle-notch",
                spin: "",
                class: "tw-h-4 tw-w-4"
              }))
            : (_ctx.icon)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 1,
                  icon: _ctx.icon,
                  class: "tw-h-4 tw-w-4"
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default")
        ], 16, _hoisted_2))
}